import { MinusIcon, PlusIcon } from '@heroicons/react/solid';
import clsxm from '@/lib/clsxm';

interface NumberInputProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  className?: string;
}

export default function NumberInput({
  value,
  onChange,
  min = 1,
  max = 4,
  disabled = false,
  className,
}: NumberInputProps) {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div
      className={clsxm(
        'relative flex items-center justify-between gap-0.5 rounded-xl shadow-sm border border-gray-200 bg-white px-2 py-1.5 dark:border-white/10 dark:bg-slate-700/50',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      <button
        type='button'
        onClick={handleDecrease}
        disabled={disabled || value <= min}
        className={clsxm(
          'flex h-6 w-5 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-slate-600',
          (disabled || value <= min) &&
            'cursor-not-allowed opacity-30 hover:bg-transparent dark:hover:bg-transparent',
        )}
        aria-label='Decrease number of images'
      >
        <MinusIcon className='h-4 w-4' />
      </button>

      <span className='w-6 text-center text-sm font-medium text-gray-700 dark:text-gray-200'>
        {value}
      </span>

      <button
        type='button'
        onClick={handleIncrease}
        disabled={disabled || value >= max}
        className={clsxm(
          'flex h-6 w-5 items-center justify-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-slate-600',
          (disabled || value >= max) &&
            'cursor-not-allowed opacity-30 hover:bg-transparent dark:hover:bg-transparent',
        )}
        aria-label='Increase number of images'
      >
        <PlusIcon className='h-4 w-4' />
      </button>
    </div>
  );
}
